import React from 'react';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

import PrimaryButton from '../../../components/buttons/primary-button';

import styles from './styles';

import ErrorImg from './images/404-error@2x.png';

const Description = styled(Typography)(styles.description);

const Error404 = () => (
    <main>
        <Container>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <Typography variant="h1" sx={styles.title}>
                    404
                </Typography>

                <Description variant="h2">
                    Page not found.
                </Description>

                <Description variant="body1" sx={{ pb: 5 }}>
                    The page you are looking for does not exist.
                </Description>

                <PrimaryButton
                    component={Link}
                    to="/"
                    className="mt-4 mb-3"
                >
                    Back to Home
                </PrimaryButton>

                <Box sx={styles.iconContainer}>
                    <img src={ErrorImg} alt="" height="190" width="313" />
                </Box>
            </Box>
        </Container>
    </main>
);

export default Error404;
